
//Constants
const TOGGLE_STEPS_ENABLED = 'TOGGLE_STEPS_ENABLED';
const SET_TOTAL_STEPS = 'SET_TOTAL_STEPS';
const SET_TODAY_STEPS = 'SET_TODAY_STEPS';

//Interfaces
interface StepState {
  stepsEnabled: boolean;
  totalSteps: number;
  stepsToday: number;
}

interface SetTotalStepsAction {
  type: typeof SET_TOTAL_STEPS;
  totalSteps: number;
}

interface SetTodayStepsAction {
  type: typeof SET_TODAY_STEPS;
  todaySteps: number;
}

interface ToggleStepsEnabledAction {
  type: typeof TOGGLE_STEPS_ENABLED;
  payload: boolean;
}

const initialState: StepState = {
  stepsEnabled: false,
  totalSteps: 0,
  stepsToday: 0,
};

//actions
export const setTotalSteps = (totalSteps: number): SetTotalStepsAction => ({
  type: SET_TOTAL_STEPS,
  totalSteps,
});

export const setTodaySteps = (todaySteps: number): SetTodayStepsAction => ({
  type: SET_TODAY_STEPS,
  todaySteps,
});

export const toggleStepsEnabled = (payload: boolean): ToggleStepsEnabledAction => ({
  type: TOGGLE_STEPS_ENABLED,
  payload,
});

interface SetTotalStepsAction {
  type: typeof SET_TOTAL_STEPS;
  totalSteps: number;
}

interface SetTodayStepsAction {
  type: typeof SET_TODAY_STEPS;
  todaySteps: number;
}

interface ToggleStepsEnabledAction {
  type: typeof TOGGLE_STEPS_ENABLED;
  payload: boolean
}

type StepAction = SetTotalStepsAction | SetTodayStepsAction | ToggleStepsEnabledAction;

const stepReducer = (state = initialState, action: StepAction): StepState => {
  switch (action.type) {
    case TOGGLE_STEPS_ENABLED:
      // console.log('TOGGLE_STEPS_ENABLED:', action);
      return {
        ...state,
        stepsEnabled: state.stepsEnabled,
      };
    case SET_TOTAL_STEPS:
      // console.log('SET_TOTAL_STEPS:', action);
      return {
        ...state,
        totalSteps: action.totalSteps,
      };
    case SET_TODAY_STEPS:
      // console.log('SET_TODAY_STEPS:', action);
      return {
        ...state,
        stepsToday: action.todaySteps,
      };
    default:
      return state;
  }
};

export default stepReducer;
